import { render, staticRenderFns } from "./BankIntegration.vue?vue&type=template&id=01fda138"
import script from "./BankIntegration.vue?vue&type=script&lang=js"
export * from "./BankIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports